module.exports = require("vue2-leaflet");


//////////////////
// WEBPACK FOOTER
// external "vue2-leaflet"
// module id = 6
// module chunks = 0